import React from "react"
import LabelBadge from "./badge.component"

interface OwnProps {
    data: {
        id: string
        title: string
        type: string
    }[]
}

export const LabelBadges = ({ data }: OwnProps) => {

    if(!data || !Array.isArray(data)) return <></>

    return data.map( label => {
        return <LabelBadge key={label.id} value={label} className={"badge badge-pill mr-1"}/>
    })
}


// WEBPACK FOOTER //
// ./src/common/label/LabelBadges.tsx